import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import {motion} from 'framer-motion';

const {FiUsers, FiCheck} = FiIcons;

const WhoIsThisFor = () => {
  const container = {
    hidden: {opacity: 0},
    show: {opacity: 1, transition: {staggerChildren: 0.2}}
  };

  const item = {
    hidden: {opacity: 0, y: 20},
    show: {opacity: 1, y: 0, transition: {duration: 0.5}}
  };

  return (
    <section className="bg-white py-16 sm:py-20 lg:py-28 relative overflow-hidden">
      {/* Background elements */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-blue-50 rounded-full mix-blend-multiply filter blur-3xl opacity-30 -translate-x-1/3 -translate-y-1/3"></div>
      <div className="absolute bottom-0 right-0 w-[400px] h-[400px] bg-purple-50 rounded-full mix-blend-multiply filter blur-3xl opacity-30 translate-x-1/3 translate-y-1/3"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div 
          className="text-center mb-12 sm:mb-16"
          initial={{opacity: 0, y: 20}}
          whileInView={{opacity: 1, y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
        >
          <div className="inline-flex items-center bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <SafeIcon icon={FiUsers} className="mr-2" />
            Perfect For
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-6">Who Is This For?</h2>
          <p className="text-lg sm:text-xl text-text-light max-w-3xl mx-auto">
            Built for busy professionals who need consistent, high-quality content
          </p>
        </motion.div>

        <motion.div 
          className="bg-white rounded-2xl sm:rounded-3xl shadow-2xl border border-gray-100 overflow-hidden"
          initial={{opacity: 0, y: 40}}
          whileInView={{opacity: 1, y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
        >
          <div className="grid md:grid-cols-3 gap-0">
            {[
              {
                title: "Founders & Solopreneurs",
                description: "Who need to maintain an active social presence while focusing on growth",
                benefits: [
                  "Save time on content creation",
                  "Maintain consistent posting",
                  "Focus on core business"
                ]
              },
              {
                title: "Agencies & Managers", 
                description: "Who handle multiple clients and need to scale content creation efficiently",
                benefits: [
                  "Manage multiple brands easily",
                  "Scale content production",
                  "Improve client results"
                ]
              },
              {
                title: "Small Business Owners",
                description: "Who want to post more consistently without the headache of content creation",
                benefits: [
                  "No need for a content team",
                  "Professional-quality posts",
                  "Consistent scheduling"
                ]
              }
            ].map((profile, index) => (
              <div 
                key={index} 
                className={`p-8 sm:p-10 ${index === 1 ? 'bg-blue-50 border-x border-blue-100' : ''}`}
              >
                <div className="mb-8">
                  <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
                    <SafeIcon icon={FiUsers} className="text-primary text-2xl" />
                  </div>
                  <h4 className="text-xl font-bold text-text mb-3">{profile.title}</h4>
                  <p className="text-text-light">{profile.description}</p>
                </div>

                <ul className="space-y-3">
                  {profile.benefits.map((benefit, i) => (
                    <li key={i} className="flex items-center">
                      <div className="w-5 h-5 bg-primary/10 rounded-full flex items-center justify-center mr-2 flex-shrink-0">
                        <SafeIcon icon={FiCheck} className="text-primary text-xs" />
                      </div>
                      <span className="text-sm text-text-light">{benefit}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhoIsThisFor;